// eslint-disable-next-line max-classes-per-file
import { InfrastructureError } from '@goodt-wcore/errors';

export class DatasetQuerySyntaxError extends InfrastructureError {
    constructor(message, { code, data, reason } = {}) {
        super(message, { code, data, reason });
        this.name = 'DatasetQuerySyntaxError';
    }
}
